/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { ReactNode } from "react";
import Fade from "@mui/material/Fade";

type FormFaderProps = {
  timeout?: number;
  children: ReactNode;
};

const FormFader = ({ timeout = 1200, children }: FormFaderProps) => {
  return (
    <Fade in={true} timeout={{ enter: timeout }}>
      <div>{children}</div>
    </Fade>
  );
};

export default FormFader;
